import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { toJsDate } from '../utils/dateUtils';

const POSTER_BASE = 'https://image.tmdb.org/t/p/w500';

function MediaCard({ item, actions, subtitle, onClick }) {
  const [hovered, setHovered] = useState(false);

  const posterUrl = item.posterPath ? `${POSTER_BASE}${item.posterPath}` : null;
  const jsDate = toJsDate(item.releaseDate);
  const year = jsDate ? jsDate.getFullYear() : '';

  return (
    <Card
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        width: 160,
        flexShrink: 0,
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        transform: hovered ? 'scale(1.04)' : 'scale(1)',
        boxShadow: hovered
          ? '0 0px 10px rgba(255, 199, 15, 0.02)'
          : '0 0px 10px rgba(255, 199, 15, 0.04)',
        position: 'relative',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      {/* Poster */}
      <Box sx={{ position: 'relative', width: 160, height: 240, bgcolor: 'action.hover' }}>
        {posterUrl ? (
          <CardMedia
            component="img"
            image={posterUrl}
            alt={item.title}
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <Box sx={{
            width: '100%', height: '100%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Typography variant="caption" color="text.secondary" align="center" sx={{ px: 1 }}>
              No Poster
            </Typography>
          </Box>
        )}

        {/* Type badge */}
        <Chip
          label={item.type === 'tv' ? 'TV' : 'Movie'}
          size="small"
          color={item.type === 'tv' ? 'secondary' : 'primary'}
          sx={{
            position: 'absolute', top: 8, left: 8,
            height: 20, fontSize: '0.65rem', fontWeight: 700,
          }}
        />

        {/* Hover overview overlay */}
        <Fade in={hovered && !!item.overview}>
          <Box sx={{
            position: 'absolute', inset: 0,
            bgcolor: 'rgba(0,0,0,0.85)',
            p: 1.5,
            overflow: 'hidden',
            display: 'flex', alignItems: 'flex-start',
          }}>
            <Typography variant="caption" sx={{ color: '#e0e0e0', lineHeight: 1.5 }}>
              {item.overview && item.overview.length > 200
                ? item.overview.slice(0, 200) + '…'
                : item.overview}
            </Typography>
          </Box>
        </Fade>
      </Box>

      {/* Title & year/subtitle */}
      <CardContent sx={{ p: '8px 10px 4px !important' }}>
        <Typography
          variant="body2"
          fontWeight={600}
          noWrap
          title={item.title}
        >
          {item.title}
        </Typography>
        {subtitle !== undefined ? (
          subtitle ? <Typography variant="caption" color="text.secondary">{subtitle}</Typography> : null
        ) : (
          year && <Typography variant="caption" color="text.secondary">{year}</Typography>
        )}
      </CardContent>

      {/* Actions */}
      {actions && (
        <CardActions
          onClick={(e) => e.stopPropagation()}
          sx={{ p: '0 10px 10px', display: 'flex', gap: 0.75, flexWrap: 'wrap', '& > :not(style) ~ :not(style)': { ml: 0 } }}
        >
          {actions}
        </CardActions>
      )}
    </Card>
  );
}

export default MediaCard;
